import { ActionTree } from 'vuex';

import { RootState } from '@/store/types';

import { subscribableStore } from './common';
import { UnitsState } from './types';

const actions: ActionTree<UnitsState, RootState> = {
  ...subscribableStore.actions,
};

export default actions;
